import { render, staticRenderFns } from "./modalAddApplicationAccess.vue?vue&type=template&id=be12efde&"
import script from "./modalAddApplicationAccess.vue?vue&type=script&lang=js&"
export * from "./modalAddApplicationAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports